export default "__VITE_ASSET__DuHvHM38__"